import React from "react";
import "./clientFooter.scss";
import logo from "../../images/logo.svg";
import { NavLink } from "react-router-dom";

const ClientFooter = () => {
  return (
    <footer className="client-footer">
      <div className="footer-content">
        {/* Logo */}
        <div className="footer-logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Contact Info */}
        <div className="footer-info">
          <p className="footer-title">Old Kent Shisha</p>
          <p>350 Old Kent Road</p>
          <p>SE1 5AA</p>
          <p className="telephone">020 7701 4646</p>
          <p>
            <a href="mailto:hello@oldkentshisha.co.uk">
              hello@oldkent-shisha.co.uk
            </a>
          </p>
          <p>
            <a
              href="https://maps.google.com/?q=350+Old+Kent+Road+SE1+5AA"
              target="_blank"
              rel="noopener noreferrer"
              className="view-map"
            >
              View Map
            </a>
          </p>
          <br />
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <NavLink className="left" to="/policies">
          Terms & Condition / Privacy Notice and Consent
        </NavLink>
        <p className="right">© Ramna 2024</p>
      </div>
    </footer>
  );
};

export default ClientFooter;
